import './orders.css';
import { useFetchData } from '../../../hooks/useFetchData';
import { useAuthContext } from '../../../hooks/useAuthContext';
import { useEffect, useState } from 'react';
import { useTable, useSortBy, useFilters } from 'react-table';
import OrderListTable from './OrderListTable';
import OrderCard from './OrderCard';
import Transaction from "./Transaction";
import { formatArabicDate } from '../../../utils/dateformat';

function Orders() {
  const { auth } = useAuthContext();
  const [columns, setColumns] = useState([]); 
  const [rows, setRows] = useState([]); 

  const { data: transactionData, loading, error } = useFetchData(
    "mandoub/transaction?id=" + auth?.user._id,
    [auth]
  );

  useEffect(() => {
    if (transactionData?.transactions) {
      const formattedData = transactionData.transactions.map((order) => ({
        order: order._id,
        date: formatArabicDate(order.createdAt),
        client: order.clientName,
        phone: order.clientPhone,
        category: order.category.name,
        categoryImage: order.category.icon?.[0]?.url, 
        fromOrders: order.fromOrders, 
        quantity: order.qte,
      }));

      setRows(formattedData);
    }

    const selectedColumns = [
      {
        Header: 'الطلب',
        accessor: 'order',
        filterable: true,
        Cell: ({ value }) => (
          <div className="order-id">
            <span>{value}</span>
          </div>
        ),
      },
      {
        Header: 'التاريخ',
        accessor: 'date',
        filterable: true,
        Cell: ({ value }) => <span>{value}</span>,
      },
      {
        Header: 'الطريقة',
        accessor: 'fromOrders',
        filterable: true,
        Cell: ({ value }) => <span className={`status ${value? "pending" : "delivered"}`}>{value ? "من الطلبات" : "عملية مباشرة"}</span>,
      },
      {
        Header: 'الفئة',
        accessor: 'category',
        filterable: true,
        Cell: ({ value, row }) => (
          <div className="category-cell df">
            {row.original.categoryImage ? (
              <img
                src={row.original.categoryImage}
                alt={value}
                style={{ width: 30, height: 30, marginRight: 5 }}
              />
            ) : (
              <span>No image</span>
            )}
            <span>{value}</span>
          </div>
        ),
      },
      {
        Header: 'الكمية',
        accessor: 'quantity',
        filterable: true,
        Cell: ({ value }) => <span>{value}</span>,
      },
      {
        Header: 'العميل',
        accessor: 'client',
        filterable: true,
        Cell: ({ value }) => <span>{value}</span>,
      },
      {  
        Header: 'الهاتف',
        accessor: 'phone',
        filterable: true,
        Cell: ({ value }) => <span>{value ? value : "N/A"}</span>,
      },
    ];

    setColumns(selectedColumns); 
  }, [transactionData]);

  const tableInstance = useTable(
    {
      columns,
      data: rows,
    },
    useFilters,
    useSortBy
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows: tableRows,
    prepareRow,
    setFilter,
  } = tableInstance;

  if (loading) return <div>تحميل...</div>;
  if (error) return <div>حدث خطأ: {error.message}</div>;

  return (
    <div className="orders df-c">
      <OrderCard />
       <OrderListTable />
       <Transaction />
      <div className="section-card rt" style={{ height: 460, width: '100%', marginTop: '1rem' }}>
        معاملاتك الأخيرة
        <div className="df-c tu" >

          {/* Filtering */}
          <input
            type="text"
            placeholder="ابحث..."
            onChange={(e) => setFilter('order', e.target.value)} // Filter by order
          />

          <div style={{ overflow:"scroll",  maxHeight: '42vh', width: '100%' }}>
          <table {...getTableProps()} className="react-table">
            <thead className="text-right">
              {headerGroups?.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup?.headers.map((column) => (
                    <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                      {column.render('Header')}
                      <span>
                        {column.isSorted
                          ? column.isSortedDesc
                            ? ' 🔽'
                            : ' 🔼'
                          : ''}
                      </span>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {tableRows?.map((row) => {
                prepareRow(row);
                return (
                  <tr  {...row.getRowProps()}>
                    {row?.cells.map((cell) => (
                      <td className='cell' {...cell.getCellProps()}>{cell.render('Cell')}</td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </table>
          </div>

          
        </div>
      </div>
    </div>
  );
}

export default Orders;
